document.addEventListener('DOMContentLoaded', () => {

  // Add -centered class to formItem--email and form-actions elements
  const emailFormItem = document.querySelector('.webform-submission-form-leadfolders-node-3397-form .formItem.formItem--email.formItem--e-mailadres, .webform-submission-form-leadfolders-node-3479-form .formItem.formItem--email.formItem--e-mailadres');
  const formActions = document.querySelector('.webform-submission-form-leadfolders-node-3397-form .form-actions.webform-actions.js-form-wrapper.form-wrapper, .webform-submission-form-leadfolders-node-3479-form .form-actions.webform-actions.js-form-wrapper.form-wrapper');

  if (!emailFormItem || !formActions) {
    console.log('Required elements not found.');
    return;
  }

  emailFormItem.classList.add('-centered');
  formActions.classList.add('-centered');

  // Create the count display element
  const countDisplay = document.createElement('p');

  const emailFormItemParent = emailFormItem.parentNode;

  if (!emailFormItemParent) {
    console.log('Email form item parent not found.');
    return;
  }

  emailFormItemParent.insertBefore(countDisplay, emailFormItem);

  const updateCount = () => {
    countDisplay.innerHTML = `Vul uw e-mailadres in en ontvang de folders die u hebt aangeduid.`;
  };

  // Attach event listener to checkboxes
  document.querySelectorAll('.formItem__input--checkbox').forEach(checkbox => {
    checkbox.addEventListener('change', updateCount);
  });

  // Initial count update
  updateCount();
});
